import { css } from 'styled-components';
import {
  getSpacing, getTypography, BreakpointQueryName, TypographyName, SpacingName, ThemedFunctor, FontWeight, grid, gridUnit,
} from '@doveit/lego';

export const content: ThemedFunctor = ({ theme }) => css`
  ${grid(theme)}
  ${getSpacing.margin(theme, [SpacingName.MEDIUM, SpacingName.NEGATIVE_SMALL, 0])}
`;

export const intro: ThemedFunctor = ({ theme, $image }) => css`
  ${$image && gridUnit(theme, { size: { LG: 7 / 12 } })}
  ${getSpacing.padding(theme, [0, SpacingName.SMALL])}
`;

export const imageBox: ThemedFunctor = ({ theme }) => css`
  ${gridUnit(theme, { size: { LG: 5 / 12 } })}
  ${getSpacing.padding(theme, [0, SpacingName.SMALL])}
  display: none;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: block;
  }
`;

export const image = css`
  box-shadow: -1.25rem 1.25rem 1.25rem rgba(0,0,0,0.15);
  line-height: 0;
  position: relative;
  z-index: 1;
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H1)}
  color: ${theme.palettes.brand.primary};
  max-width: 57rem;
  font-weight: ${FontWeight.NORMAL};

  strong {
    font-weight: ${FontWeight.BOLD};
  }
`;

export const description: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  font-weight: ${FontWeight.NORMAL};
  max-width: 60rem;

  p + p {
    ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  }
`;

export const children: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
`;
